function showWhenVisible(selector) {
  const elements = document.querySelectorAll(selector);
  const sticky = document.querySelector(".sticky_add_to_cart");
  if (!elements.length) {
    console.log("No elements found for:", selector);
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        sticky.classList.add("visible");
      }
    });
  });

  elements.forEach(el => observer.observe(el));
}

showWhenVisible(".section-product-description");

function hideWhenVisible(selector) {
  const elements = document.querySelectorAll(selector);
  const sticky = document.querySelector(".sticky_add_to_cart");
  if (!elements.length) {
    console.log("No elements found for:", selector);
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        sticky.classList.remove("visible");
      }
    });
  });

  elements.forEach(el => observer.observe(el));
}

hideWhenVisible(".product-title");

const params = new URLSearchParams(window.location.search);
const customerPosted = params.get('customer_posted');

if (customerPosted === 'true') {
  const getPopup = document.querySelector(".popup-minimal");
  getPopup.style.display = "none";
  console.log('Customer posted is true');
}

function moveAppBlock() {
  const appBlock = document.querySelector('.monk-app-block');

  if (!appBlock) return;

  if (window.innerWidth >= 768) {

    const desktopContainer = document.querySelectorAll('#MainContent .product-media-container')[0]?.appendChild(appBlock);

    if (desktopContainer) {
      desktopContainer.appendChild(appBlock);
    }
  } else {
    const mobileContainer = document.querySelectorAll('#MainContent .product-content-container')[0]?.appendChild(appBlock);

    if (mobileContainer) {
      mobileContainer.appendChild(appBlock);
    }
  }
}

document.addEventListener('DOMContentLoaded', moveAppBlock);
window.addEventListener('resize', moveAppBlock);


window.addEventListener('load', function () {
  const host = document.querySelector('#ShopifyChat'); 
  const style = document.createElement('style');

  style.textContent = `
  @media(min-width:768px){
    .chat-app .chat-toggle{
      width: 90px !important;
      max-width: 90px !important;
      height: 40px !important;
      transition: all .3s;
    }
    .chat-app .chat-toggle svg{
      height:30px!important;
      transition: all .3s;
    }
    .chat-app .chat-toggle .chat-title{
      font-size: 16px!important;
      height: 30px!important;
      transition: all .3s;
    }
  }
  @media(max-width:767px){
    .chat-app .chat-toggle{
      width: 40px !important;
      max-width: 40px !important;
      height: 40px !important;
      transition: all .3s;
    }
    .chat-app .chat-toggle svg{
      height:30px!important;
      transition: all .3s;
    }
  }
  `;

  host.shadowRoot.appendChild(style);
  console.log(host?.shadowRoot);



  const shopifyChat = document.querySelector('#ShopifyChat');

  window.addEventListener('scroll', () => {
    if (window.innerWidth >= 1025) {
      if (window.scrollY > 900) {
        shopifyChat.style.setProperty('bottom', '90px', 'important');
      } else {
        shopifyChat.style.setProperty('bottom', '0px', 'important');
      }
    }
    if (window.innerWidth >= 992 && window.innerWidth <= 1024) {
      if (window.scrollY > 300) {
        shopifyChat.style.setProperty('bottom', '90px', 'important');
      } else {
        shopifyChat.style.setProperty('bottom', '0px', 'important');
      }
    }
    if (window.innerWidth >= 768 && window.innerWidth <= 991) {
      if (window.scrollY > 400) {
        shopifyChat.style.setProperty('bottom', '90px', 'important');
      } else {
        shopifyChat.style.setProperty('bottom', '0px', 'important');
      }
    }
  });
});


